export default __webpack_public_path__ + "static/email-1d5c36a424271e8574fa9ab8e58a6aec.png";